import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from "react";
import { sortByKey } from "@notemeal/utils-sort";
import { ServingAmountViewChip } from "./Chip";
export const ServingAmountViewChipList = ({ servingAmounts, hideLimitedAccessWarning, onRemoveServing }) => {
    const sortedServingAmounts = sortByKey(servingAmounts, "position");
    return (_jsx(Fragment, { children: sortedServingAmounts.map(sa => (_jsx(ServingAmountViewChip, { servingAmount: sa, hideLimitedAccessWarning: hideLimitedAccessWarning, onRemoveServing: onRemoveServing }, sa.serving.id))) }));
};
//# sourceMappingURL=ChipList.js.map